import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'login_and_security';
export const route = 'login_and_security/[[...slug]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "loginandsecurity" */
'../../components/LoginAndSecurity')));